import { Component } from '@angular/core';
import { NavController, NavParams } from 'ionic-angular';

/**
 * Generated class for the BusinessProductPaymentDetailPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */


@Component({
  selector: 'page-business-product-payment-detail',
  templateUrl: 'business-product-payment-detail.html',
})
export class BusinessProductPaymentDetailPage {

  constructor(public navCtrl: NavController, public navParams: NavParams) {
  }

  ionViewDidLoad() {
    console.log('ionViewDidLoad BusinessProductPaymentDetailPage');
  }

}



// WEBPACK FOOTER //
// ./src/pages/business-product-payment-detail/business-product-payment-detail.ts